import {Directive, Input, OnInit} from '@angular/core';
import {NgControl} from "@angular/forms";

@Directive({
    selector: 'input[disableControl]',
    standalone: false
})
export class DisableControlDirective implements OnInit {

    @Input() set disableControl(condition: boolean) {
        if (this._ngControl.control) {
            this.toggleControl(condition);
        }
        this.condition = condition;
    }

    private condition: boolean;

    constructor(private _ngControl: NgControl) {}

    ngOnInit(): void {
        this.toggleControl(this.condition);
    }

    private toggleControl(condition: boolean): void {
        const action = condition ? 'disable' : 'enable';
        this._ngControl.control[action]();
    }
}
